export default __webpack_public_path__ + "static/scientist-microscope-c64e278636033c3b624f0877e6690948.webm";